module.exports = __webpack_public_path__ + "img/GoodFic-success.129cccb1.png";